import * as R from 'ramda';
import AddressInfo from '../addressInfo';
import {FrenchTypes} from '../../utils/connectionTypes';

export default function Ehpad(data) {
    let activity = data || {};
    this.type = FrenchTypes.ehpad;
    this.address = R.isNil(data) || R.isNil(data.address) ? new AddressInfo() : new AddressInfo(data.address);
    this.name =  activity.name;
}